// extracted by mini-css-extract-plugin
export default {"tasks":"gM-z","task":"hM-z","svg":"iM-z","text":"jM-z"};